export const DISCOUNT_HEIGHT = 40;
export const DISCOUNT_WIDTH = 40;
export const COUPON_EXPIRED = 'Coupon expired';
export const OFFER_EXPIRED = 'Offer expired';

//EXPIRY_THRESHOLD_TIME signifies the number of milliseconds in 12h.
export const EXPIRY_THRESHOLD_TIME = 43200000;
